import React from 'react';

export default function FCMComponent({
  children,
}: React.PropsWithChildren<{}>) {
  return children;
}
